import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtogadagcabs() {



    const cardData = {




keyword: "Belgaum to Gadag Cabs",

headingDescription: "Belgaum Taxi Service offers comfortable and reliable Belgaum to Gadag cab services for business travel, family trips, medical visits, educational purposes, pilgrimage journeys, and outstation transportation. We provide one-way taxi, round-trip cab, and customized travel options with experienced drivers and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, and groups. With doorstep pickup, flexible travel schedules, transparent pricing, easy booking, and 24/7 customer support, we ensure a safe and convenient journey between Belgaum and Gadag. Whether you are traveling for work, family functions, sightseeing, or personal requirements, Belgaum Taxi Service provides dependable cab solutions for a comfortable outstation experience.",

topPlaces: [
  {
    title: "Gadag",
    description: "Gadag is an important city in Karnataka known for its historical importance, temples, literature, education, and commercial activities. The city attracts visitors for business purposes, religious visits, and exploring nearby heritage attractions. Gadag is also known for its connection with famous Kannada poets and cultural heritage."
  },
  {
    title: "Trikuteshwara Temple",
    description: "Trikuteshwara Temple is one of the most famous historical attractions in Gadag, known for its beautiful Chalukyan architecture, intricate carvings, and religious significance. It is a popular destination for devotees, history enthusiasts, and tourists visiting Gadag."
  },
  {
    title: "Lakkundi",
    description: "Lakkundi is a heritage village near Gadag famous for ancient temples, step wells, and remarkable architectural structures from the Chalukya period. It is an ideal destination for travelers interested in history, culture, and traditional architecture."
  },
  {
    title: "Kappattagudda",
    description: "Kappattagudda is a scenic hill range near Gadag known for greenery, trekking opportunities, medicinal plants, and peaceful natural surroundings. It is a preferred destination for nature lovers and weekend travelers."
  },
  {
    title: "Badami",
    description: "Badami is a famous heritage destination in Karnataka known for rock-cut cave temples, sandstone cliffs, and ancient Chalukyan architecture. It attracts tourists interested in history, photography, and cultural exploration."
  },
  {
    title: "Pattadakal",
    description: "Pattadakal is a UNESCO World Heritage Site famous for beautifully designed temples and historical monuments representing the rich architectural heritage of Karnataka. It is a popular sightseeing destination near Gadag."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site known for magnificent ruins, ancient temples, royal structures, and historical landscapes. It is one of Karnataka's most visited tourist destinations and a popular addition to heritage tours."
  },
  {
    title: "Hubballi",
    description: "Hubballi is a major commercial city in North Karnataka known for business centers, hospitals, educational institutions, shopping areas, and transportation connectivity. It is an important destination for corporate and personal travel."
  },
  {
    title: "Dharwad",
    description: "Dharwad is an educational and cultural city famous for universities, traditional arts, music, and peaceful surroundings. It is a preferred destination for students, professionals, and family travelers."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination known for beaches, resorts, churches, water activities, and scenic coastal attractions. Many travelers combine Karnataka trips with Goa vacations using private cab services for comfortable travel."
  }
],




 "services": [
    {
      "name": "Belgaum to Gadag Cabs",
      "description": "Book Belgaum to Gadag Cabs for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Get Sedan, Ertiga, Innova Crysta, and SUV cab options for family trips, business travel, airport transfers, and convenient journeys between Belgaum and Gadag with flexible one way and round trip booking facilities."
    },
    {
      "name": "Belgaum to Gadag Cab",
      "description": "Hire Belgaum to Gadag Cab service for a smooth and hassle-free journey with experienced drivers, clean vehicles, and affordable travel packages. Our cabs provide comfortable transportation for personal trips, corporate travel, family tours, and long-distance travel requirements."
    },
    {
      "name": "Belgaum to Gadag Taxi",
      "description": "Choose Belgaum to Gadag Taxi for reliable intercity transportation with professional drivers, transparent pricing, and multiple vehicle options. Travel comfortably with Sedan, Ertiga, and Innova Crysta taxis available for one way and round trip journeys."
    },
    {
      "name": "Belgaum to Gadag Cab Service",
      "description": "Book Belgaum to Gadag Cab Service for convenient outstation travel with doorstep pickup, experienced chauffeurs, and well-maintained vehicles. Our taxi services are suitable for families, corporate passengers, airport transfers, and sightseeing trips."
    },
    {
      "name": "Belgaum to Gadag Taxi Service",
      "description": "Get Belgaum to Gadag Taxi Service with comfortable AC cars, professional drivers, affordable fares, and flexible booking options. Enjoy a safe and convenient journey from Belgaum to Gadag for business, personal, and family travel."
    },
    {
      "name": "Belgaum to Gadag One Way Cab",
      "description": "Book Belgaum to Gadag One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, comfortable seating, clean vehicles, and reliable chauffeur services for your one way journey."
    },
    {
      "name": "Belgaum to Gadag One Way Taxi",
      "description": "Choose Belgaum to Gadag One Way Taxi for affordable and convenient transportation with professional drivers and flexible pickup options. Perfect for passengers looking for budget-friendly one direction travel solutions."
    },
    {
      "name": "Belgaum to Gadag Cab Booking",
      "description": "Complete Belgaum to Gadag Cab Booking online with easy reservations, quick confirmation, and multiple vehicle choices. Select from Sedan, Ertiga, Innova Crysta, and premium cabs according to your travel requirements."
    },
    {
      "name": "Belgaum to Gadag Taxi Booking",
      "description": "Reserve Belgaum to Gadag Taxi Booking services for comfortable and reliable travel with experienced chauffeurs. Get affordable taxi options with flexible schedules for local, family, and corporate journeys."
    },
    {
      "name": "Belgaum to Gadag Car Rental",
      "description": "Choose Belgaum to Gadag Car Rental for private chauffeur-driven vehicles with comfortable seating and professional service. Ideal for business trips, family travel, sightseeing, and outstation transportation."
    },
    {
      "name": "Belgaum to Gadag Outstation Cab",
      "description": "Hire Belgaum to Gadag Outstation Cab for safe and comfortable long-distance travel. Enjoy reliable transportation with AC vehicles, skilled drivers, transparent fares, and flexible one way or round trip packages."
    },
    {
      "name": "Belgaum to Gadag Innova Crysta Cab",
      "description": "Book Belgaum to Gadag Innova Crysta Cab for premium and spacious travel with luxury seating, large luggage capacity, and experienced chauffeurs. Perfect for family groups, corporate travel, and comfortable outstation journeys."
    },
    {
      "name": "Belgaum to Gadag Ertiga Cab",
      "description": "Choose Belgaum to Gadag Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Ideal for family trips, airport transfers, and long-distance journeys."
    },
    {
      "name": "Belgaum to Gadag Sedan Cab",
      "description": "Book Belgaum to Gadag Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Suitable for individuals, couples, business trips, and smooth highway journeys."
    },
    {
      "name": "Belgaum to Gadag Round Trip Cab",
      "description": "Hire Belgaum to Gadag Round Trip Cab for convenient return journeys with affordable packages and flexible travel schedules. Perfect for family visits, business meetings, sightseeing, and weekend trips."
    },
    {
      "name": "Belgaum to Gadag Private Taxi",
      "description": "Reserve Belgaum to Gadag Private Taxi for a personalized travel experience with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and hassle-free transportation throughout your journey."
    },
    {
      "name": "Cheap Belgaum to Gadag Cab",
      "description": "Find Cheap Belgaum to Gadag Cab services offering affordable fares without compromising safety and comfort. Get reliable vehicles, experienced drivers, and budget-friendly travel solutions."
    },
    {
      "name": "Best Belgaum to Gadag Cab Service",
      "description": "Choose the Best Belgaum to Gadag Cab Service with premium vehicles, trained drivers, competitive pricing, and dependable customer support. Experience smooth and comfortable travel for all types of journeys."
    },
    {
      "name": "Online Belgaum to Gadag Cab Booking",
      "description": "Complete Online Belgaum to Gadag Cab Booking with simple reservations, instant confirmation, and flexible travel options. Select your preferred vehicle and enjoy convenient doorstep pickup service."
    },
    {
      "name": "Belgaum to Gadag Taxi Fare",
      "description": "Check Belgaum to Gadag Taxi Fare for affordable and transparent pricing with no hidden charges. Get comfortable cabs with professional drivers for safe and economical travel."
    },
    {
      "name": "Belgaum to Gadag Car Hire",
      "description": "Hire Belgaum to Gadag Car Hire services for comfortable private travel with chauffeur-driven vehicles. Choose from multiple car categories for personal, family, and corporate transportation needs."
    },
    {
      "name": "Belgaum to Gadag Cab Price",
      "description": "Get affordable Belgaum to Gadag Cab Price with flexible packages for one way and round trips. Enjoy quality vehicles, reliable service, and professional drivers at competitive rates."
    },
    {
      "name": "Belgaum to Gadag Family Cab",
      "description": "Book Belgaum to Gadag Family Cab for safe and comfortable family travel with spacious vehicles and experienced chauffeurs. Perfect for vacations, family functions, and personal visits."
    },
    {
      "name": "Belgaum to Gadag Corporate Taxi",
      "description": "Choose Belgaum to Gadag Corporate Taxi services for business travel, employee transportation, and executive journeys. Get punctual service with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Belgaum to Gadag Airport Transfer",
      "description": "Book Belgaum to Gadag Airport Transfer services for timely airport pickup and drop with comfortable vehicles and professional chauffeurs. Enjoy stress-free airport transportation with reliable cab availability."
    },
    {
      "name": "Belgaum to Gadag Cab Fare",
      "description": "Get the best Belgaum to Gadag Cab Fare with affordable travel packages and transparent pricing. Travel comfortably with Sedan, Ertiga, Innova Crysta, and SUV cab options."
    },
    {
      "name": "Belgaum to Gadag Taxi Near Me",
      "description": "Find Belgaum to Gadag Taxi Near Me for quick and reliable cab availability with professional drivers. Enjoy convenient booking, doorstep pickup, and comfortable travel anytime."
    },
    {
      "name": "Belgaum to Gadag Outstation Taxi",
      "description": "Book Belgaum to Gadag Outstation Taxi for safe and convenient long-distance travel. Get clean AC vehicles, experienced chauffeurs, and flexible travel plans for personal and business journeys."
    },
    {
      "name": "Belgaum to Gadag Travel by Cab",
      "description": "Experience comfortable Belgaum to Gadag Travel by Cab with reliable transportation, professional drivers, and premium vehicle options. Enjoy a smooth journey with convenient pickup and customized travel solutions."
    }
  ],
  "tableData": [
    ["Belgaum to Gadag Cabs", "Belgaum to Gadag Cab"],
    ["Belgaum to Gadag Taxi", "Belgaum to Gadag Cab Service"],
    ["Belgaum to Gadag Taxi Service", "Belgaum to Gadag One Way Cab"],
    ["Belgaum to Gadag One Way Taxi", "Belgaum to Gadag Cab Booking"],
    ["Belgaum to Gadag Taxi Booking", "Belgaum to Gadag Car Rental"],
    ["Belgaum to Gadag Outstation Cab", "Belgaum to Gadag Innova Crysta Cab"],
    ["Belgaum to Gadag Ertiga Cab", "Belgaum to Gadag Sedan Cab"],
    ["Belgaum to Gadag Round Trip Cab", "Belgaum to Gadag Private Taxi"],
    ["Cheap Belgaum to Gadag Cab", "Best Belgaum to Gadag Cab Service"],
    ["Online Belgaum to Gadag Cab Booking", "Belgaum to Gadag Taxi Fare"],
    ["Belgaum to Gadag Car Hire", "Belgaum to Gadag Cab Price"],
    ["Belgaum to Gadag Family Cab", "Belgaum to Gadag Corporate Taxi"],
    ["Belgaum to Gadag Airport Transfer", "Belgaum to Gadag Cab Fare"],
    ["Belgaum to Gadag Taxi Near Me", "Belgaum to Gadag Outstation Taxi"],
    ["Belgaum to Gadag Travel by Cab", ""]
  ],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Gadag Cab Service",
    WhyChoosedescription: "Travel comfortably from Belgaum to Gadag with a trusted taxi service offering well-maintained vehicles, professional drivers, and convenient travel options for every journey."
  },
  {
    WhyChooseheading: "Convenient Doorstep Pickup & Drop",
    WhyChoosedescription: "Enjoy hassle-free transportation with pickup from your preferred location in Belgaum and direct drop service anywhere in Gadag."
  },
  {
    WhyChooseheading: "Multiple Cab Options Available",
    WhyChoosedescription: "Select from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on passenger count, luggage requirements, and comfort preferences."
  },
  {
    WhyChooseheading: "Suitable for Business & Family Travel",
    WhyChoosedescription: "Our Belgaum to Gadag cabs are ideal for business visits, family trips, personal work, medical travel, and regular transportation needs."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Journey",
    WhyChoosedescription: "Professional chauffeurs ensure smooth driving, timely service, and comfortable travel with proper knowledge of the Belgaum to Gadag route."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Booking",
    WhyChoosedescription: "Choose a one-way taxi for direct travel or plan a return journey according to your preferred timing and travel requirements."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Outstation Trips",
    WhyChoosedescription: "Travel in clean and well-maintained cars with spacious seating designed to provide a relaxed experience throughout your Belgaum to Gadag journey."
  },
  {
    WhyChooseheading: "Quick Cab Booking Assistance",
    WhyChoosedescription: "Get support for vehicle selection, fare details, and taxi availability to arrange your Belgaum to Gadag cab service easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Gadag Cabs?",
    answer: "Yes, we provide Belgaum to Gadag cab services with comfortable vehicles and professional drivers for convenient outstation travel."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Gadag?",
    answer: "Yes, one-way cab services are available for passengers who need direct transportation between Belgaum and Gadag."
  },
  {
    question: "Which cars are available for Belgaum to Gadag travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your travel needs."
  },
  {
    question: "Is Belgaum to Gadag cab suitable for family trips?",
    answer: "Yes, comfortable and spacious vehicles are available for families, senior citizens, and groups travelling between Belgaum and Gadag."
  },
  {
    question: "Can I book a return cab from Gadag to Belgaum?",
    answer: "Yes, return journey taxi options are available with flexible schedules based on your travel plan."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Gadag?",
    answer: "Yes, private cab services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Gadag taxi service available anytime?",
    answer: "Yes, taxi booking assistance is available for planned trips and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Gadag Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Naik",
    feedback: "The Belgaum to Gadag cab service was comfortable and reliable. The driver was punctual, and the vehicle condition was excellent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shweta Kulkarni",
    feedback: "We travelled with family and had a smooth journey. The cab was clean, spacious, and the overall service was very convenient.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Gadag Cabs",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-gadag-cabs.webp",
  "description":
    "Book Belgaum to Gadag Cabs with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Gadag with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, temple visits, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-gadag-cabs"
  }
};





    return (
        <div>


<Helmet>
  <title>Belgaum to Gadag Cabs | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Gadag Cabs with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs for affordable and comfortable outstation travel from Belgaum to Gadag with 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Belgaum to Gadag Cabs, Belgaum to Gadag Cab, Belgaum to Gadag Taxi, Belgaum to Gadag Cab Service, Belgaum to Gadag Taxi Service, Belgaum to Gadag One Way Cab, Belgaum to Gadag One Way Taxi, Belgaum to Gadag Cab Booking, Belgaum to Gadag Taxi Booking, Belgaum to Gadag Car Rental, Belgaum to Gadag Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtogadagcabs ;